var View = require('derby/lib/View'),
	escapeAttribute = View.prototype.escapeAttribute;

module.exports = {
	init: init,
	getComponentAttrs: getComponentAttrs,
	renderAttrs: renderAttrs
};

// The init function is called on both the server and browser
// before rendering
function init(model) {
    args = getComponentAttrs(model);

    //Used for the `for` attribute of the label,
    //and for the `name` attribute of the input element for the more specific form helpers (field-text, field-textarea, etc.)
    if (!args.name) args.name = args.id;
	model.set('name', args.name);

	setClassAttr('row-class', 'field');
	setClassAttr('label-class', 'field-label' + (args.required ? ' required': '') );
	setClassAttr('item-class', 'field-item');

	function setClassAttr(attrName, mainClass) {
		var additionalClasses = args[attrName] || '';
		model.set(attrName, (mainClass + (' ' + additionalClasses)).trim() );
		delete args[attrName];
	}

	//Do some cleanup, so that the return value can be assumed to be only remaining regular HTML attributes
	delete args.label;
	return args;
}

//Get a copy of the component's attributes
function getComponentAttrs(model) {
	var args = model.get(),
		argsCopy = {};
    //make a copy of the component attrutes, so we don't modify the actual model
	for (var key in args) argsCopy[key] = args[key];
	delete argsCopy['$null'];
	return argsCopy;
}

//Outputs attributes as HTML string
function renderAttrs(attrs) {
	var value,
		html = '', glue = '';

	for (var key in attrs) {
		//model-view bindings need to work on "value" attributes, so we need to render them in the component template
		if (key=='value') continue;

		value = attrs[key];
		if (value !== true) {
			html += glue + key + '=' + escapeAttribute(value);
		}
		else html += glue + key;
		glue = ' ';
	}

	if (html != '') html = ' ' + html;
	return html;
}